import { FC, SVGProps } from 'react'

export const CaretDown: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M6 7L8 9L10 7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
